import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "grid gap-6 grid-cols-2 w-full" }
const _hoisted_2 = /*#__PURE__*/_createVNode("hr", { class: "my-6 col-span-4 border-gray-lp-400" }, null, -1)
const _hoisted_3 = { class: "grid gap-6 grid-cols-4 w-12/12" }
const _hoisted_4 = {
  key: 0,
  class: "col-span-4"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("hr", { class: "mt-6 w-full border-gray-lp-400" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("hr", { class: "mt-3 col-span-4 border-gray-lp-400" }, null, -1)
const _hoisted_7 = { class: "w-full flex flex-row justify-between items-center" }
const _hoisted_8 = { class: "flex flex-row ml-1" }
const _hoisted_9 = {
  key: 0,
  class: "bg-yellow-lp-200 rounded text-center text-yellow-lp-100 font-medium text-xs px-1"
}
const _hoisted_10 = {
  key: 1,
  class: "ml-1 bg-red-lp-600 rounded text-center text-red-lp-1600 font-medium text-xs px-1"
}
const _hoisted_11 = { class: "flex flex-row ml-1" }
const _hoisted_12 = {
  key: 0,
  class: "bg-yellow-lp-200 rounded text-center text-yellow-lp-100 font-medium text-xs px-1"
}
const _hoisted_13 = {
  key: 1,
  class: "ml-1 bg-red-lp-600 rounded text-center text-red-lp-1600 font-medium text-xs px-1"
}
const _hoisted_14 = /*#__PURE__*/_createVNode("hr", { class: "mt-3 col-span-4 border-gray-lp-400" }, null, -1)
const _hoisted_15 = { class: "items-center justify-end flex flex-row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SelectSearch = _resolveComponent("SelectSearch")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_Title = _resolveComponent("Title")!
  const _component_lp_input = _resolveComponent("lp-input")!
  const _component_CustomDropdown = _resolveComponent("CustomDropdown")!
  const _component_select_district = _resolveComponent("select-district")!
  const _component_AddressTypeSelect = _resolveComponent("AddressTypeSelect")!
  const _component_Estimation = _resolveComponent("Estimation")!
  const _component_ModalV2 = _resolveComponent("ModalV2")!

  return (_openBlock(), _createBlock(_component_ModalV2, {
    title: _ctx.$t('Ubah Data Alamat'),
    onClose: _ctx.closeModal
  }, {
    content: _withCtx(() => [
      (_ctx.posField)
        ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
            _createVNode("div", _hoisted_1, [
              _createVNode(_component_DataWrapper, {
                label: "POS",
                asterisk: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_SelectSearch, {
                    onFocus: _ctx.filterPartners,
                    onFilter: _ctx.filterPartners,
                    isLoading: _ctx.isLoadingPartners,
                    options: _ctx.partnersData,
                    keyName: "name",
                    keyValue: "id",
                    placeholder: _ctx.$t('customProcess.selectPos'),
                    modelValue: _ctx.selectedPartnerPos,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedPartnerPos = $event)),
                    onChange: _ctx.onChangePartner,
                    class: "mt-2",
                    isDisabled: _ctx.isUserHasPartnerPos
                  }, null, 8, ["onFocus", "onFilter", "isLoading", "options", "placeholder", "modelValue", "onChange", "isDisabled"])
                ]),
                _: 1
              })
            ]),
            _hoisted_2
          ], 64))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_3, [
        (!_ctx.posField)
          ? (_openBlock(), _createBlock("div", _hoisted_4, [
              _createVNode(_component_Title, {
                fontSize: 20,
                class: "w-full pb-3",
                label: _ctx.$t('customProcess.deliveryDetail')
              }, null, 8, ["label"]),
              _createVNode(_component_DataWrapper, {
                label: _ctx.$t('customProcess.deliveryProduct'),
                asterisk: "",
                class: "w-1/2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_SelectSearch, {
                    options: 
                _ctx.isHiddenOnepack
                  ? _ctx.productsDeliveryWithoutOnePack
                  : _ctx.productsDelivery
              ,
                    onFilter: _ctx.filterProductsDelivery,
                    onFocus: _ctx.filterProductsDelivery,
                    keyName: "name",
                    keyValue: "name",
                    placeholder: _ctx.$t('customProcess.chooseProduct'),
                    modelValue: _ctx.form.product,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.form.product = $event)),
                    isLoading: _ctx.isLoadingProduct,
                    onChange: _ctx.onSelectProduct,
                    class: "w-full whitespace-no-wrap mt-1.5 z-10"
                  }, null, 8, ["options", "onFilter", "onFocus", "placeholder", "modelValue", "isLoading", "onChange"])
                ]),
                _: 1
              }, 8, ["label"]),
              _hoisted_5
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_DataWrapper, {
          label: _ctx.$t('customProcess.senderName'),
          asterisk: "",
          class: "col-span-2"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_lp_input, {
              modelValue: _ctx.dataSender.name,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.dataSender.name = $event)),
              placeholder: "John Doe",
              disabled: ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_DataWrapper, {
          label: _ctx.$t('customProcess.receiverName'),
          asterisk: "",
          class: "col-span-2"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_lp_input, {
              modelValue: _ctx.form.consigneeName,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.form.consigneeName = $event)),
              disabled: 
              _ctx.isCodRetail || _ctx.shipmentC1SpecialCod || _ctx.shipmentFavoritCodDfod
            
            }, null, 8, ["modelValue", "disabled"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_DataWrapper, {
          label: _ctx.$t('customProcess.senderAddress'),
          asterisk: "",
          class: "col-span-2"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_lp_input, {
              modelValue: _ctx.dataSender.address,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.dataSender.address = $event)),
              placeholder: "Jl. Puri Indah Raya No.8, RT.1/RW.8, Kembangan Sel., Kec. Kembangan, Kota Jakarta Barat, Daerah Khusus Ibukota Jakarta 11610",
              type: "textarea",
              disabled: ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_DataWrapper, {
          label: _ctx.$t('customProcess.receiverAddress'),
          asterisk: "",
          class: "col-span-2"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_lp_input, {
              modelValue: _ctx.form.consigneeAddress,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.form.consigneeAddress = $event)),
              type: "textarea",
              disabled: 
              _ctx.isCodRetail || _ctx.shipmentC1SpecialCod || _ctx.shipmentFavoritCodDfod
            
            }, null, 8, ["modelValue", "disabled"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_DataWrapper, {
          label: _ctx.$t('customProcess.senderPhone'),
          asterisk: "",
          class: "col-span-2"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_lp_input, {
              prefix: "+62",
              modelValue: _ctx.dataSender.phoneNumber,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.dataSender.phoneNumber = $event)),
              placeholder: "899838833",
              disabled: ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_DataWrapper, {
          label: _ctx.$t('customProcess.receiverPhone'),
          asterisk: "",
          class: "col-span-2"
        }, {
          default: _withCtx(() => [
            (!_ctx.isMultipleConsigneePhone)
              ? (_openBlock(), _createBlock(_component_lp_input, {
                  key: 0,
                  prefix: "+62",
                  format: _ctx.formatNumber,
                  modelValue: _ctx.form.consigneePhone,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.form.consigneePhone = $event)),
                  debounce: 500,
                  onChange: _ctx.validateConsigneePhone,
                  error: _ctx.error.consigneePhone,
                  errorCaption: _ctx.$t('customProcess.receiverPhonePlaceholder'),
                  maxLength: "12",
                  placeholder: "81119600999",
                  disabled: 
              _ctx.isCodRetail || _ctx.shipmentC1SpecialCod || _ctx.shipmentFavoritCodDfod
            
                }, null, 8, ["format", "modelValue", "onChange", "error", "errorCaption", "disabled"]))
              : (_openBlock(), _createBlock(_component_CustomDropdown, {
                  key: 1,
                  class: "my-1.5 w-full",
                  placeholder: _ctx.$t('Pilih No. Telepon Penerima'),
                  options: _ctx.multipleConsigneePhone,
                  onSelect: _ctx.onSelectConsigneePhone,
                  selectedItem: _ctx.selectedItemConsigneePhone,
                  isCustomWidth: "",
                  isCustomMaxHeight: ""
                }, null, 8, ["placeholder", "options", "onSelect", "selectedItem"]))
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_DataWrapper, {
          label: _ctx.$t('customProcess.district'),
          asterisk: "",
          class: "col-span-2"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_lp_input, {
              modelValue: _ctx.dataSender.district,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.dataSender.district = $event)),
              placeholder: "Surabaya, Surabaya",
              disabled: ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_DataWrapper, {
          label: _ctx.$t('customProcess.districtCity'),
          asterisk: "",
          class: "col-span-2"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_select_district, {
              class: "mt-1.5",
              placeholder: _ctx.$t('customProcess.chooseCity'),
              modelValue: _ctx.form.destinationCity,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.form.destinationCity = $event)),
              isShowErrorIndicator: _ctx.isErrorCod || _ctx.isForwardArea,
              errorCaption: _ctx.errorDistrictDestination,
              hideErrorIcon: "",
              status: "active",
              paramsType: _ctx.paramsType,
              paramsExcludeCountry: _ctx.paramsExcludeCountry,
              onChange: _ctx.onSelectDistrict,
              key: _ctx.form.product,
              isDisabled: 
              _ctx.isCodRetail || _ctx.shipmentC1SpecialCod || _ctx.shipmentFavoritCodDfod
            
            }, null, 8, ["placeholder", "modelValue", "isShowErrorIndicator", "errorCaption", "paramsType", "paramsExcludeCountry", "onChange", "isDisabled"])
          ]),
          _: 1
        }, 8, ["label"]),
        (_ctx.isVisiblePostalCode)
          ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
              _createVNode(_component_DataWrapper, {
                isDefault: false,
                class: "col-span-2"
              }),
              _createVNode(_component_DataWrapper, {
                label: _ctx.$t('customProcess.posCode'),
                asterisk: "",
                class: "col-span-2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lp_input, {
                    modelValue: _ctx.form.postalCode,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.form.postalCode = $event)),
                    placeholder: "00000",
                    type: "number",
                    maxLength: "6"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"])
            ], 64))
          : _createCommentVNode("", true),
        _createVNode(_component_DataWrapper, {
          isDefault: false,
          class: "col-span-2"
        }),
        _createVNode(_component_DataWrapper, {
          label: _ctx.$t('customProcess.addressType'),
          asterisk: "",
          class: "col-span-2"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_AddressTypeSelect, {
              modelValue: _ctx.form.addressType,
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.form.addressType = $event)),
              class: "w-full",
              isDisabled: _ctx.isCodRetail && !_ctx.sttCodCaRetail
            }, null, 8, ["modelValue", "isDisabled"])
          ]),
          _: 1
        }, 8, ["label"]),
        (!_ctx.posField)
          ? (_openBlock(), _createBlock(_Fragment, { key: 2 }, [
              _hoisted_6,
              _createVNode(_component_Title, {
                fontSize: 20,
                class: "col-span-4",
                label: _ctx.$t('customProcess.itemDetail')
              }, null, 8, ["label"]),
              _createVNode(_component_DataWrapper, {
                label: _ctx.$t('customProcess.commodityType'),
                asterisk: "",
                class: "col-span-2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_SelectSearch, {
                    id: "select-search_komoditas_update-custom-status",
                    class: "mt-1.5",
                    options: _ctx.commodities,
                    onFilter: _ctx.fetchCommodityList,
                    onFocus: _ctx.fetchCommodityList,
                    keyName: "commodity_name",
                    keyValue: "commodity_code",
                    placeholder: _ctx.$t('customProcess.typeCommodity'),
                    modelValue: _ctx.form.commodity,
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.form.commodity = $event)),
                    useInfiniteScroll: "",
                    onChange: _ctx.onSelectCommodity,
                    onScrolled: _ctx.fetchCommodityListInfiniteScroll
                  }, {
                    "custom-option": _withCtx(({item}) => [
                      _createVNode("div", _hoisted_7, [
                        _createVNode("div", null, _toDisplayString(item.commodity_name), 1),
                        _createVNode("div", _hoisted_8, [
                          (item.isQuarantine)
                            ? (_openBlock(), _createBlock("span", _hoisted_9, " K "))
                            : _createCommentVNode("", true),
                          (item.isDangerousGoods)
                            ? (_openBlock(), _createBlock("span", _hoisted_10, " DG "))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]),
                    "selected-info": _withCtx(({selected}) => [
                      _createVNode("div", _hoisted_11, [
                        (selected && selected.isQuarantine)
                          ? (_openBlock(), _createBlock("span", _hoisted_12, " K "))
                          : _createCommentVNode("", true),
                        (selected && selected.isDangerousGoods)
                          ? (_openBlock(), _createBlock("span", _hoisted_13, " DG "))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _: 1
                  }, 8, ["options", "onFilter", "onFocus", "placeholder", "modelValue", "onChange", "onScrolled"])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_DataWrapper, {
                label: _ctx.$t('customProcess.deliveryStatus'),
                optional: "",
                class: "col-span-2",
                tooltipTitle: _ctx.$t('customProcess.deliveryStatus'),
                tooltipDescription: _ctx.$t('customProcess.deliveryStatusDesc')
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_CustomDropdown, {
                    class: "mt-1.5 w-full",
                    isExpand: _ctx.isOpenSelectStatus,
                    "onUpdate:isExpand": _cache[14] || (_cache[14] = ($event: any) => (_ctx.isOpenSelectStatus = $event)),
                    options: _ctx.listGoodsStatus,
                    onSelect: _ctx.onSelectStatus,
                    placeholder: _ctx.$t('customProcess.chooseStatus'),
                    isCustomWidth: "",
                    isCustomMaxHeight: "",
                    selectedItem: _ctx.form.goodsStatus
                  }, null, 8, ["isExpand", "options", "onSelect", "placeholder", "selectedItem"])
                ]),
                _: 1
              }, 8, ["label", "tooltipTitle", "tooltipDescription"]),
              _createVNode(_component_DataWrapper, {
                label: _ctx.$t('customProcess.tax'),
                optional: "",
                class: "col-span-2",
                tooltipTitle: _ctx.$t('customProcess.tax'),
                tooltipDescription: _ctx.$t('customProcess.taxDesc')
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lp_input, {
                    modelValue: _ctx.form.taxNumber,
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.form.taxNumber = $event)),
                    format: _ctx.formattedNPWP,
                    placeholder: "00.000.000.0-000.000",
                    maxLength: "20",
                    "show-max-length": ""
                  }, null, 8, ["modelValue", "format"])
                ]),
                _: 1
              }, 8, ["label", "tooltipTitle", "tooltipDescription"])
            ], 64))
          : _createCommentVNode("", true),
        (_ctx.form.isFtz)
          ? (_openBlock(), _createBlock(_Fragment, { key: 3 }, [
              _hoisted_14,
              _createVNode(_component_Title, {
                class: "col-span-4",
                label: "Free Trade Zone"
              }),
              _createVNode(_component_DataWrapper, {
                label: "Piece Per Pack",
                asterisk: "",
                tooltipTitle: "Piece Per Pack",
                tooltipDescription: _ctx.$t('customProcess.pcpDesc'),
                class: "col-span-2",
                disabled: !_ctx.form.isFtzEditable
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lp_input, {
                    modelValue: _ctx.form.sttPiecePerPack,
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.form.sttPiecePerPack = $event)),
                    format: _ctx.formatPiecePerPack,
                    placeholder: _ctx.$t('customProcess.enterPcp')
                  }, null, 8, ["modelValue", "format", "placeholder"])
                ]),
                _: 1
              }, 8, ["tooltipDescription", "disabled"]),
              _createVNode(_component_DataWrapper, {
                label: _ctx.$t('customProcess.nextCommodity'),
                asterisk: "",
                tooltipTitle: _ctx.$t('customProcess.nextCommodity'),
                tooltipDescription: _ctx.$t('customProcess.nextCommodityDesc'),
                class: "col-span-2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lp_input, {
                    modelValue: _ctx.form.sttNextCommodity,
                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.form.sttNextCommodity = $event)),
                    placeholder: _ctx.$t('customProcess.enterNext'),
                    disabled: !_ctx.form.isFtzEditable
                  }, null, 8, ["modelValue", "placeholder", "disabled"])
                ]),
                _: 1
              }, 8, ["label", "tooltipTitle", "tooltipDescription"])
            ], 64))
          : _createCommentVNode("", true)
      ])
    ]),
    footer: _withCtx(() => [
      _createVNode("div", _hoisted_15, [
        _createVNode(_component_Estimation, {
          form: _ctx.form,
          onOnSubmit: _ctx.onSubmitEditAddress,
          disabledSubmit: _ctx.disabledSubmit,
          key: _ctx.estimationKey,
          posIDForInternal: _ctx.posIDForInternal
        }, null, 8, ["form", "onOnSubmit", "disabledSubmit", "posIDForInternal"])
      ])
    ]),
    _: 1
  }, 8, ["title", "onClose"]))
}